"use client";

import { graphql, useQuery } from "@opensea/graphql";
import { uniq } from "es-toolkit/array";
import { useState } from "react";
import { withSuspense } from "@/components/suspense/WithSuspense";
import { PricePanel, PricePanelSkeleton } from "./PricePanel";
const query = graphql(`
  query CollectionPricePanel($collectionSlug: String!) {
    collectionBySlug(slug: $collectionSlug) {
      __typename
      ... on Collection {
        chain {
          listingCurrency {
            symbol
          }
        }
      }
    }
  }
`);
const CONTEXT = {
  ttl: Number.POSITIVE_INFINITY
};
export const CollectionPricePanel = withSuspense(function CollectionPricePanel({
  collectionSlug
}) {
  const [open, setOpen] = useState(false);
  const [{
    data
  }] = useQuery({
    query,
    variables: {
      collectionSlug
    },
    pause: !open,
    context: CONTEXT
  });
  const collection = data?.collectionBySlug;
  const symbol = collection?.__typename === "Collection" && collection.chain ? collection.chain.listingCurrency.symbol : "USD";
  return <PricePanel currencyOptions={uniq([symbol, "USD"])} defaultCurrency={symbol} key={symbol} nativeCurrency={symbol} onOpenChange={setOpen} open={open} />;
}, {
  fallback: <PricePanelSkeleton open />
});